<template>
  <v-app id="inspire">
      
      <Header />
      <Aside />
      <Content />  
      <v-overlay :value="overlay" z-index="9999" v-if="loadingFetch">
        <v-progress-circular indeterminate size="50"></v-progress-circular>
      </v-overlay>
    
  </v-app>
</template>

<script>

  import Aside from './component/layouts/aside'
  import Header from './component/layouts/header'
  import Content from './pages'
  import Loading from './component/helpers/loading'


  export default {
    props: {
      source: String,
    },

    components:{

      Aside,
      Header,
      Content,
      Loading

    },

    data: () => ({
      dialog: false,
     
      
    }),


    computed: {
      
      loading(){

        return this.$store.state.loading;

      },
      loadingFetch(){
        return this.$store.state.loadingFetch
      }

    },

  }
</script>